import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import MyPagination from "Components/MyPagination";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import IconButton from '@material-ui/core/IconButton';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import { message } from "constants/message";
import {
  MuiPickersUtilsProvider,
  DateTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Toolbar from '@material-ui/core/Toolbar';
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);



const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  dateWrapper: {
    display: "flex",
    marginTop: theme.spacing(2),
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  table: {
    overflowX: "auto",
    marginBottom: theme.spacing(2),
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "105px",
  },
  buttonRed: {
    color: "#fff",
    backgroundColor: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgb(154, 0, 54)",
    },
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 120,
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 110,
    paddingRight: 110,
    width: "110%",
    marginLeft: -20,
    marginRight: -20
  },
}));

function Logs(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();
  const queryParams = useQueryString();

  const [validFrom, setValidFrom] = React.useState(null);
  const [validUntil, setValidUntil] = React.useState(null);
  const [user, setUser] = React.useState("");
  const [operation, setOperation] = React.useState("");
  const [status, setStatus] = React.useState(null);
  const [api, setApi] = React.useState("");
  const [method, setMethod] = React.useState("");
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [limit, setLimit] = React.useState(50);
  const [totalCount, setTotalCount] = React.useState(0);

  // const [adminuser, setAdminuser] = React.useState(
  //   [
  //     {"id": 1, "title": "n.mizunuma+super@nttcoms.com",},
  //     {"id": 2, "title": "y.nisikawa+super@nttcoms.com",},
  //     {"id": 3, "title": "t.matsumoto+super@nttcoms.com",},
  //   ]
  // );

  const [logs, setLogs] = React.useState([]);

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 操作ログ";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchLogs();
  }, [auth.state.token]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      fetchLogs();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  const fetchLogs = () => {
    request({
      method: "GET",
      url: `admin/logs?${convertQueryParam({
        // range: [fromDate, toDate],
        // filter: requestFilter,
        // order: order,
        pagination: {
          page: page,
          limit: 50,
        },
      })}`,
    }).then((result) => {
      setLogs(result.data.data);
      setTotalCount(result.data.meta.total_count);
    });

    // TODO: 管理者一覧取得
  };

  // const dateError = (error, value) => {
  //   if (error) {
  //     setIsdisable(true);
  //   }
  //   return;
  // }

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{dayjs(row.date).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell>{row.user}</TableCell>
          <TableCell>{row.operation}</TableCell>
          <TableCell>{row.api}</TableCell>
          <TableCell>{row.method}</TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  // const onError = () => {
  //   stateError.dispatch({
  //     type: "set",
  //     payload: {
  //       isError: true,
  //       errorMsg: messages.validation.common,
  //     },
  //   });
  // };

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <>
          <Grid container spacing={3}>
            <Toolbar className={classes.sticky}>
              <Grid item xs={12}>
                <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                  <MyPagination
                  count={Math.ceil(totalCount / 50)}
                  currentPage={page}
                  handlePagination={(page) => setPage(page)}
                  />
                </Grid>
              </Grid>
            </Toolbar>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                操作ログ
              </Typography>
              {/* TODO: 絞り込み機能 */}
              {/* <ValidatorForm
                onSubmit={(e) => {
                  e.preventDefault();
                  submit({ name, email, password, userType });
                }}
                onError={onError}
              >
                <Grid container>
                  <Grid item xs={12} className={classes.dateWrapper}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DateTimePicker
                        label="開始日時"
                        format="yyyy/MM/dd HH:mm:ss"
                        value={validFrom}
                        onChange={(date) => dateValidation(date, "validFrom")}
                      />
                    </MuiPickersUtilsProvider>
                    <div className={classes.divider}>〜</div>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DateTimePicker
                        label="終了日時"
                        format="yyyy/MM/dd HH:mm:ss"
                        value={validUntil}
                        onChange={(date) => dateValidation(date, "validUntil")}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <TextValidator
                      label="ログ内容"
                      type="text"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.wrapper}>
                    <Autocomplete
                      id="combo-box-demo"
                      options={adminuser}
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => <TextField {...params} label="管理者" variant="outlined" />}
                    />
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" className={classes.wrapper}>
                  <Button type="submit" variant="contained" color="primary">
                    絞込
                  </Button>
                </Grid>
              </ValidatorForm> */}
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>日時</TableCell>
                    <TableCell>管理者</TableCell>
                    <TableCell>操作対象</TableCell>
                    <TableCell>操作API</TableCell>
                    <TableCell>アクション</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logs.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </>
      }
    />
  );
}

export default withRouter(Logs);
